import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom'


export default function Header(){
    const location = useLocation();

    let headerClasses = "";
    let subMenu = "";
    let navItems = "";
    let colNavItems = "";
    let NavLogo = "";

    if(location.pathname == "/"){
        headerClasses = "ltn__header-area ltn__header-5 ltn__header-logo-and-mobile-menu-in-mobile ltn__header-logo-and-mobile-menu ltn__header-transparent gradient-color-4---";
        subMenu = "ltn__header-top-area top-area-color-white";
        navItems = "ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-black";
        colNavItems = "col header-menu-column menu-color-white";

        NavLogo = "img/logo-2.png";
    }else{
        headerClasses = "ltn__header-area ltn__header-5 ltn__header-transparent--- gradient-color-4---";
        subMenu = "ltn__header-top-area section-bg-6 top-area-color-white---";
        navItems = "ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white";
        colNavItems = "col header-menu-column";

        NavLogo = "img/logo.png";
    }

    return(
        <header className={headerClasses}>
            <div class={subMenu}>
                <div class="container">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="ltn__top-bar-menu">
                                <ul>
                                    <li><i class="icon-call"></i> 0984 24454</li>
                                    <li><a href="locations.html"><i class="icon-placeholder"></i> Piazza Giacomo Mancini 18, 87100 Cosenza (CS)</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="top-bar-right text-end">
                                <div class="ltn__top-bar-menu">
                                    <ul>
                                        
                                        <li>
                                          
                                            <div class="ltn__social-media">
                                                <ul>
                                                    <li><a href="#" title="Facebook"><i class="fab fa-facebook-f"></i></a></li>
                                                    <li><a href="#" title="Twitter"><i class="fab fa-twitter"></i></a></li>
                                                    
                                                    <li><a href="#" title="Instagram"><i class="fab fa-instagram"></i></a></li>
                                                    <li><a href="#" title="Dribbble"><i class="fab fa-dribbble"></i></a></li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class={navItems}>
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="site-logo-wrap">
                                <div class="site-logo">
                                    <a href="/"><img src={NavLogo} alt="Logo"/></a>
                                </div>
                                <div class="get-support clearfix d-none">
                                    <div class="get-support-icon">
                                        <i class="icon-call"></i>
                                    </div>
                                    <div class="get-support-info">
                                        <h6>Chiamaci</h6>
                                        <h4><a href="tel:+123456789">0984 24454</a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class={colNavItems}>
                            <div class="header-menu d-none d-xl-block">
                                <nav>
                                    <div class="ltn__main-menu">
                                        <ul>
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/ricerca">Ricerca</a></li>
                                        <li><a href="/chi-siamo">Chi Siamo</a></li>
                                        <li><a href="/contatti">Contatti</a></li>
                                        </ul>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        <div class="col--- ltn__header-options ltn__header-options-2 ">
                       
                            <div class="mobile-menu-toggle d-xl-none">
                                <a href="#ltn__utilize-mobile-menu" class="ltn__utilize-toggle">
                                    <svg viewBox="0 0 800 600">
                                        <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top"></path>
                                        <path d="M300,320 L540,320" id="middle"></path>
                                        <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) "></path>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </header>

        

    );
}